module.exports = __webpack_public_path__ + "static/favicon-72c792c20135d9e77e09537fce87b1e9.ico";